export const followUpNotes = [
 {
    title: 'ATTEMPT 1 – NO ALT CONTACT',
    content: '1st Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. No additional contact numbers listed on the Rx'
  }, {
    title: 'ATTEMPT 1 – ALT CONTACT ADDED',
    content: '1st Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Additional contact numbers listed on the Rx added to patient\'s chart'
  }, {
    title: 'ATTEMPT 1 – EMERGENCY CONTACT',
    content: '1st Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Additional contact numbers listed on the Rx under emergency contact is'
  }, {
    title: 'ATTEMPT 2 – NO RESPONSE',
    content: '2nd Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'ATTEMPT 3 – DME CONTACT REQUESTED',
    content: '3rd Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Request sent to DME for any additional patient contact information'
  }, {
    title: 'ATTEMPT 4 – NO RESPONSE',
    content: '4th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'ATTEMPT 4 – DME FOLLOW-UP',
    content: '4th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Request sent to DME for any additional patient contact information'
  }, {
    title: 'ATTEMPT 5 – NO RESPONSE',
    content: '5th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'FINAL ATTEMPT 6 – STANDARD CLOSE',
    content: '6th (Final) Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Unable to establish contact after multiple attempts; order will be closed due to inability to reach the patient. DME and the ordering physician’s office have been notified. (STANDARD)'
  }, {
    title: 'ATTEMPT 6 – NO RESPONSE',
    content: '6th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'ATTEMPT 7 – NO RESPONSE',
    content: '7th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'ATTEMPT 8 – NO RESPONSE',
    content: '8th Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent'
  }, {
    title: 'FINAL ATTEMPT 9 – STAT CLOSE',
    content: '9th (Final) Attempt: Called patient to schedule HST; no answer. Voicemail left and text message sent. Unable to establish contact after multiple attempts; order will be closed due to inability to reach the patient. DME and the ordering physician’s office have been notified. (STAT)'
  }
]